export default __webpack_public_path__ + "static/char-s-40-zh-Hans-e845a2ffc0b17f4265b139664ffc5db5.webp";